import { fetchCurriculumData } from './dataApi';

// Skeleton + locale text table pattern (see dev/stracture.md's Speaking &
// Listening Skill Path format): the structural skeleton and English
// "meaning"/native translations live once under the `en` home (the fixed
// anchor, matching DEFAULT_SKILL_HOME); each home only carries its own
// target-language `text/{packId}.json` table.
const ANCHOR_HOME = 'en';

function fetchSkeleton(packId, options) {
  return fetchCurriculumData(ANCHOR_HOME, `speaking-listening/${packId}.json`, options);
}

function fetchNativeMeaning(readerCode, packId, options) {
  return fetchCurriculumData(ANCHOR_HOME, `speaking-listening/native/${readerCode}/${packId}.json`, options)
    .catch(() => null);
}

function fetchTargetText(targetCode, packId, options) {
  return fetchCurriculumData(targetCode, `speaking-listening/text/${packId}.json`, options);
}

// Reassembles one pack for a given target/reader language pair. Returns the
// same shape the old fully-duplicated-per-locale packs had, minus the
// title/description fields (confirmed unused by every consumer).
export async function fetchSpeakingListeningPack(targetCode, readerCode, packId, options) {
  const [skeleton, text, nativeMeaning] = await Promise.all([
    fetchSkeleton(packId, options),
    fetchTargetText(targetCode, packId, options),
    readerCode === ANCHOR_HOME ? null : fetchNativeMeaning(readerCode, packId, options),
  ]);
  return {
    ...skeleton,
    items: skeleton.items.map((item) => ({
      ...item,
      text: text[item.id],
      meaning: nativeMeaning?.[item.id] || item.meaning.txt,
    })),
  };
}

// Lighter-weight variant for consumers that only need target-language text
// (e.g. the audio slideshow fallback) — skips the native-meaning fetch.
export async function fetchSpeakingListeningText(targetCode, packId, options) {
  const [skeleton, text] = await Promise.all([
    fetchSkeleton(packId, options),
    fetchTargetText(targetCode, packId, options),
  ]);
  return {
    ...skeleton,
    items: skeleton.items.map((item) => ({ ...item, text: text[item.id] })),
  };
}
